import React from 'react';
export const About = () => {
  return <section id="about" className="w-full py-20 px-6 md:px-12 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-2/5 mb-10 md:mb-0">
            <div className="w-72 h-72 mx-auto overflow-hidden rounded-full">
              <img src="/IMG_9318.jpg" alt="Professional headshot" className="w-full h-full object-cover object-center" />
            </div>
          </div>
          <div className="md:w-3/5 md:pl-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              My Approach to Growth
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Jack Carlson is a growth-focused digital marketer specializing in
              social media advertising, email marketing, and sales pages.
              Helping businesses increase their revenue through strategic
              marketing initiatives, delivering content specific to your niche
              at budgets you can afford.
            </p>
            <p className="text-gray-600 leading-relaxed">
              What sets these services apart is their approach to supporting
              business journeys. It meets clients exactly where they are
              today—no complicated commitments or irrelevant metrics. Instead of
              pushing generic solutions, it offers straightforward options
              tailored specifically to each client's goals. Businesses simply
              share what matters most to them right now, and can start with
              something simple that creates real value.
            </p>
          </div>
        </div>
      </div>
    </section>;
};